module.exports = __webpack_public_path__ + "static/media/forgot_password.13ecc68a.png";